<template>
  <div class="dashboard-bd">
    <div class="dashboard-wrap">
      <img class="bg-img" src="../../images/dashboard/dashboard_bg.png" alt="" />
      <div class="bg-box">
        <div class="title">
          <h1>
            {{ userInfo.realName }},
            <span>{{ timeDay }}</span>
          </h1>
          <p>{{ $t('dashboard.jtsoohyhdiynergyglpt', [today,weekday]) }}</p>
        </div>
        <div class="card ub">
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.my_device" @click="onCardJump('/other/device')">
            <div class="box-l">
              <h1>{{ $t('dashboard.wo_de_ji_qi') }}</h1>
              <p>{{ `${dashboardCount.deviceCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #00a0d9">
              <i class="icon icon-shebei"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.not_used_device" @click="onCardJump('/other/device')">
            <div class="box-l">
              <h1>{{ $t('dashboard.wsyjq7t') }}</h1>
              <p>{{ `${dashboardCount.unCleanDeviceCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #b3b3b3">
              <i class="icon icon-shebei"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.expire_device" @click="onCardJump('/other/device', { status: 'expire', timeType: 'one' })">
            <div class="box-l">
              <h1>{{ $t('dashboard.dqjq30tn') }}</h1>
              <p>{{ `${dashboardCount.expiringDeviceCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #eb5a5a">
              <i class="icon icon-shebei"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.active_area" @click="onCardJump('/other/location')">
            <div class="box-l">
              <h1>{{ $t('dashboard.hdqy30tn') }}</h1>
              <p>{{ `${dashboardCount.useSiteCount}` || '-' }}/{{ `${dashboardCount.siteCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #00a0d9">
              <i class="icon icon-mianji"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.not_set_target" @click="onCardJump('/other/location', { tabIndex: 'area', isSetGoal: 0 })">
            <div class="box-l">
              <h1>{{ $t('dashboard.wszmbqy') }}</h1>
              <p>{{ `${dashboardCount.noGoalSiteCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #fac04c">
              <i class="icon icon-mianji"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.my_order" @click="onCardJump('/service/order')">
            <div class="box-l">
              <h1>{{ $t('dashboard.jxzgd') }}</h1>
              <p>{{ `${workOrderCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #93da49">
              <i class="icon icon-gongdan"></i>
            </div>
          </div>
          <div class="ub-f1 ub ub-sp ub-xc" v-if="funcView.bill_count" @click="onCardJump('/rent/myAccount')">
            <div class="box-l">
              <h1>{{ $t('dashboard.dfzd30tn') }}</h1>
              <p>{{ `${expiringBillCount}` || '-' }}</p>
            </div>
            <div class="box-r" style="background: #93da49">
              <i class="icon icon-gongdan"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="report-box">
        <div class="filter">
          <el-radio-group
            v-model="reportType"
            @change="onTypeChange"
            v-if="funcView.historyLine_cleanScore || funcView.historyLine_totalCleanArea || funcView.historyLine_totalUsageTime || funcView.historyLine_useDeviceSite"
          >
            <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
          </el-radio-group>
          <div class="select-date" style="float: right">
            <custom-date-picker
              v-show="reportType == '5'"
              :picker-options="beforeToday2016"
              style="width: 280px"
              v-model="reportDateTime"
              type="daterange"
              align="right"
              unlink-panels
              :init-value="initValue"
              value-format="YYYY-MM-DD HH:mm:ss"
              @change="onTypeChange"
              :clearable="false"
              :start-placeholder="$t('Common.com_start_date')"
              :end-placeholder="$t('Common.com_end_date')"
            ></custom-date-picker>
            <!-- 年 -->
            <year-picker v-show="reportType == '1'" v-model="reportYearTime" class="year-picker" @change="onTypeChange"></year-picker>
            <!-- 季 -->
            <season-picker v-show="reportType == '2'" v-model="reportSeasonTime" class="season-picker" @change="onTypeChange"></season-picker>
            <!-- 周 -->
            <week-picker v-show="reportType == '4'" v-model="reportWeekTime" class="week-picker" @change="onTypeChange"></week-picker>
            <!-- 月 -->
            <el-date-picker
              v-show="reportType == '3'"
              style="width: 240px"
              v-model="reportMonthTime"
              type="monthrange"
              range-separator="—"
              :format="$getElFormat('yyyy-MM', true)"
              value-format="yyyy-MM"
              align="right"
              placeholder=""
              :picker-options="pickerOptionsIntervalThreeYears"
              :clearable="false"
              @change="onTypeChange"
              :start-placeholder="$t('Common.com_start_month')"
              :end-placeholder="$t('Common.com_end_month')"
            ></el-date-picker>
          </div>
        </div>
        <div class="report ub">
          <div class="ub-f3" v-if="funcView.kpi_use_qualify_rate || funcView.kpi_qualify_rate">
            <h1>{{ $t('dashboard.qu_yu_da_biao_lv') }}</h1>
            <div class="wrap ub ub-sp ub-xc">
              <div class="ub-f1 ubv ub-xc" v-if="funcView.kpi_qualify_rate">
                <div class="ub ub-c" style="width: 80px; height: 80px">
                  <my-pie :pieData="formatPieDate(kpiCount.siteQualifyRate)" :score="(`${kpiCount.siteQualifyRate}` || '0') + '%'"></my-pie>
                </div>
                <p>{{ $t('dashboard.suo_you_qu_yu') }}</p>
              </div>
              <div style="background: rgba(0, 0, 0, 0.1); height: 76px; width: 0.5px" v-if="funcView.kpi_use_qualify_rate && funcView.kpi_qualify_rate"></div>
              <div class="ub-f1 ubv ub-xc" v-if="funcView.kpi_use_qualify_rate">
                <div style="width: 80px; height: 80px">
                  <my-pie :pieData="formatPieDate(kpiCount.useSiteQualifyRate)" :score="(`${kpiCount.useSiteQualifyRate}` || '0') + '%'"></my-pie>
                </div>
                <p>{{ $t('dashboard.huo_dong_qu_yu') }}</p>
              </div>
            </div>
          </div>
          <div class="ub-f3" v-if="funcView.kpi_site_score || funcView.kpi_use_site_score">
            <h1>{{ $t('dashboard.qypjdf') }}</h1>
            <div class="wrap ub ub-sp ub-xc">
              <div class="ub-f1 ubv ub-xc" v-if="funcView.kpi_site_score">
                <div style="width: 80px; height: 80px">
                  <my-pie :pieData="formatPieDate(kpiCount.siteScoreAvg)" :score="`${kpiCount.siteScoreAvg}` || '0'"></my-pie>
                </div>
                <p>{{ $t('dashboard.suo_you_qu_yu') }}</p>
              </div>
              <div style="background: rgba(0, 0, 0, 0.1); height: 76px; width: 0.5px" v-if="funcView.kpi_site_score && funcView.kpi_use_site_score"></div>
              <div class="ub-f1 ubv ub-xc" v-if="funcView.kpi_use_site_score">
                <div style="width: 80px; height: 80px">
                  <my-pie :pieData="formatPieDate(kpiCount.useSiteScoreAvg)" :score="`${kpiCount.useSiteScoreAvg}` || '0'"></my-pie>
                </div>
                <p>{{ $t('dashboard.huo_dong_qu_yu') }}</p>
              </div>
            </div>
          </div>
          <div class="ub-f4" style="flex: 7">
            <div class="ub" style="margin-bottom: 8px">
              <div class="ub-f1 sub-box" v-if="funcView.kpi_clean_total_area">
                <h1>{{ $t('Common.com_area_cleaned') }}</h1>
                <p>{{ $numCommaSplit(`${$formatLenLocal(kpiCount.cleanAreaTotal)}`) || '-' }} {{ $formatLenUnit() }}</p>
              </div>
              <div class="ub-f1 sub-box" v-if="funcView.kpi_clean_total_time">
                <h1>{{ $t('Common.com_time_cleaned') }}</h1>
                <p>{{ Number.parseInt((kpiCount.cleanTimeTotal || 0) / 60, 10) | formatHourMinute }} h:m</p>
              </div>
              <div class="ub-f1 sub-box" v-if="funcView.kpi_clean_day">
                <h1>{{ $t('dashboard.qing_jie_tian_shu') }}</h1>
                <p>{{ `${kpiCount.cleanDays}` || '-' }}/{{ diffDay }}</p>
              </div>
            </div>
            <div class="ub">
              <div class="ub-f1 sub-box" v-if="funcView.kpi_day_clean_area">
                <h1>{{ $t('dashboard.pjqjmjt') }}</h1>
                <p>{{ $numCommaSplit(`${$formatLenLocal(kpiCount.cleanAreaAvg)}`) || '-' }} {{ $formatLenUnit() }}</p>
              </div>
              <div class="ub-f1 sub-box" v-if="funcView.kpi_day_clean_time">
                <h1>{{ $t('dashboard.pjqjsct') }}</h1>
                <p>{{ Number.parseInt((kpiCount.cleanTimeAvg || 0) / 60, 10) | formatHourMinute }} h:m</p>
              </div>
              <div class="ub-f1 sub-box" v-if="funcView.kpi_day_charge_time">
                <h1>{{ $t('dashboard.pjcdsct') }}</h1>
                <p>{{ Number.parseInt((kpiCount.chargeAvg || 0) / 60, 10) | formatHourMinute }} h:m</p>
              </div>
              <div class="ub-f1 sub-box" v-if="funcView.kpi_use_site_count">
                <h1>{{ $t('dashboard.huo_dong_qu_yu') }}</h1>
                <p>{{ `${kpiCount.useSiteCount}` == 'undefined' ? '-' : kpiCount.useSiteCount }}/{{ `${kpiCount.hasMachineSiteCount}` == 'undefined' ? '-' : kpiCount.hasMachineSiteCount }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="chart" v-if="funcView.historyLine_cleanScore || funcView.historyLine_totalCleanArea || funcView.historyLine_totalUsageTime || funcView.historyLine_useDeviceSite">
          <div class="tab-wrapper" style="padding: 0 16px">
            <el-tabs v-model="lineType">
              <el-tab-pane v-if="funcView.historyLine_cleanScore" :label="$t('dashboard.de_fen')" name="cleanScore"></el-tab-pane>
              <el-tab-pane v-if="funcView.historyLine_totalCleanArea" :label="$t('Common.com_area_cleaned')" name="totalCleanArea"></el-tab-pane>
              <el-tab-pane v-if="funcView.historyLine_totalUsageTime" :label="$t('Common.com_time_cleaned')" name="totalUsageTime"></el-tab-pane>
              <el-tab-pane v-if="funcView.historyLine_useDeviceSite" :label="$t('dashboard.huo_dong_qu_yu')" name="useDeviceSite"></el-tab-pane>
            </el-tabs>
          </div>
          <my-line :lineData="lineType === 'useDeviceSite' ? lineList2 : lineList" :lineType="lineType"></my-line>
        </div>
      </div>
      <div class="clean-box" v-if="funcView.historyReport || funcView.historyTimeReport">
        <div class="tab-wrapper">
          <el-tabs v-model="tableType">
            <el-tab-pane v-if="funcView.historyReport" :label="$t('dashboard.qyqjmj')" name="cleanArea"></el-tab-pane>
            <el-tab-pane v-if="funcView.historyTimeReport" :label="$t('dashboard.qyqjsc')" name="cleanTime"></el-tab-pane>
          </el-tabs>
        </div>
        <template v-if="tableType == 'cleanArea'">
          <div class="search-content">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item style="float: right; margin-right: 0" v-if="funcView.historyExport">
                <el-button type="info" @click="onExport">
                  <i class="icon icon-export-excel"></i>
                  &nbsp;
                  <span>{{ $t('Common.com_export') }}</span>
                </el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <search-input :placeholder="$t('dashboard.xmqymc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
              <el-form-item style="float: right" v-if="isCoJv && showSubsidiary">
                <custom-select
                  class="org-select"
                  url="OrganSelect"
                  :model="formSearch"
                  :params="{ childOrgType: 'CS' }"
                  v-model="formSearch.customerId"
                  :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                  :placeholder="$t('dashboard.qing_xuan_ze_gong_si')"
                  @change="onPageChange({ page: 1 })"
                  filterable
                ></custom-select>
              </el-form-item>
            </el-form>
          </div>
          <custom-table height="450px" stripe :column="cleanColumn" :data="tableList" :slots="['locationName', 'siteName', 'month1', 'month2', 'month3', 'month4']">
            <template v-slot:locationName="scope">
              <span class="cell-link" v-if="scope.row.locationName" style="cursor: pointer" @click="onCardJump('/home/usagemonth', { status: 'machine', search: scope.row.locationName })">
                {{ scope.row.locationName }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:siteName="scope">
              <span class="cell-link" v-if="scope.row.siteName" style="cursor: pointer" @click="onCardJump('/home/usagemonth', { status: 'machine', search: scope.row.siteName })">
                {{ scope.row.siteName }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:month1="scope">
              <div class="ub" v-if="funcView.historyPercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month11, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month1) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month2="scope">
              <div class="ub" v-if="funcView.historyPercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month22, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month2) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month3="scope">
              <div class="ub" v-if="funcView.historyPercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month33, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month3) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month4="scope">
              <div class="ub" v-if="funcView.historyPercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month44, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month4) }}</span>
                </div>
              </div>
            </template>
          </custom-table>
          <custom-pagination style="padding: 24px 0 0" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
        </template>
        <template v-if="tableType == 'cleanTime'">
          <div class="search-content">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item style="float: right; margin-right: 0" v-if="funcView.historyTimeExport">
                <el-button type="info" @click="onExport2">
                  <i class="icon icon-export-excel"></i>
                  &nbsp;
                  <span>{{ $t('Common.com_export') }}</span>
                </el-button>
              </el-form-item>
              <el-form-item style="float: right">
                <search-input :placeholder="$t('dashboard.xmqymc')" v-model="formSearch2.search" @fetch="onPageChange2({ page: 1 })"></search-input>
              </el-form-item>
              <el-form-item style="float: right" v-if="isCoJv && showSubsidiary">
                <custom-select
                  class="org-select"
                  url="OrganSelect"
                  :model="formSearch2"
                  :params="{ childOrgType: 'CS' }"
                  v-model="formSearch2.customerId"
                  :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                  :placeholder="$t('dashboard.qing_xuan_ze_gong_si')"
                  @change="onPageChange2({ page: 1 })"
                  filterable
                ></custom-select>
              </el-form-item>
            </el-form>
          </div>
          <custom-table stripe height="450px" :column="cleanColumn2" :data="tableList2" :slots="['locationName', 'siteName', 'month1', 'month2', 'month3', 'month4']">
            <template v-slot:locationName="scope">
              <span class="cell-link" v-if="scope.row.locationName" style="cursor: pointer" @click="onCardJump('/home/usagemonth', { status: 'machine', search: scope.row.locationName })">
                {{ scope.row.locationName }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:siteName="scope">
              <span class="cell-link" v-if="scope.row.siteName" style="cursor: pointer" @click="onCardJump('/home/usagemonth', { status: 'machine', search: scope.row.siteName })">
                {{ scope.row.siteName }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:month1="scope">
              <div class="ub" v-if="funcView.historyTimePercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month11, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month1) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month2="scope">
              <div class="ub" v-if="funcView.historyTimePercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month22, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month2) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month3="scope">
              <div class="ub" v-if="funcView.historyTimePercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month33, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month3) }}</span>
                </div>
              </div>
            </template>
            <template v-slot:month4="scope">
              <div class="ub" v-if="funcView.historyTimePercent">
                <div style="width: 20px; height: 20px; margin-top: 2px">
                  <my-pie :radius="['60%', '100%']" :pieData="formatPieDate(scope.row.month44, 6)"></my-pie>
                </div>
                <div style="padding-left: 6px">
                  <span>{{ $numCommaSplit(scope.row.month4) }}</span>
                </div>
              </div>
            </template>
          </custom-table>
          <custom-pagination style="padding: 24px 0 0" :total="totalRows2" :page="formSearch2.pageNum" :size="formSearch2.pageSize" @change="onPageChange2"></custom-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';
import myPie from '@/components/pie.vue';
import myLine from './children/dashboard_line.vue';

export default {
  name: 'dashboard',
  components: { myLine, myPie, seasonPicker, yearPicker, weekPicker },
  computed: {
    today() {
      const d = this.$momentLocal(Date.now(), 'YYYY-MM-DD');
      return d;
    },
    weekday() {
      const arr = [this.$t('dashboard.xing_qi_ri'), this.$t('dashboard.xing_qi_yi'), this.$t('dashboard.xing_qi_er'), this.$t('dashboard.xing_qi_san'), this.$t('dashboard.xing_qi_si'), this.$t('dashboard.xing_qi_wu'), this.$t('dashboard.xing_qi_liu')];
      return arr[this.$moment(this.$getLocalTime()).get('days')];
    },
    timeDay() {
      const arr = [this.$t('dashboard.ling_chen_hao'), this.$t('dashboard.zao_shang_hao'), this.$t('dashboard.shang_wu_hao'), this.$t('dashboard.zhong_wu_hao'), this.$t('dashboard.xia_wu_hao'), this.$t('dashboard.wan_shang_hao')];
      const hour = moment(this.$getLocalTime()).hour();
      let timeOfDay = '';
      switch (true) {
        case hour >= 0 && hour < 6: // 凌晨
          timeOfDay = arr[0];
          break;
        case hour >= 6 && hour < 9: // 早上
          timeOfDay = arr[1];
          break;
        case hour >= 9 && hour < 12: // 上午
          timeOfDay = arr[2];
          break;
        case hour === 12: // 中午
          timeOfDay = arr[3];
          break;
        case hour > 12 && hour <= 17: // 下午
          timeOfDay = arr[4];
          break;
        default: // 其他情况都认为是晚上
          timeOfDay = arr[5];
      }
      return timeOfDay;
    },
    diffDay() {
      if (this.startDate && this.endDate) {
        return this.$moment(this.endDate).diff(this.$moment(this.startDate), 'days') + 1;
      }
      return '-';
    },
    reportTypeData() {
      return [
        {
          label: this.$t('dashboard.ri'),
          value: '5',
        },
        {
          label: this.$t('dashboard.zhou'),
          value: '4',
        },
        {
          label: this.$t('dashboard.yue'),
          value: '3',
        },
        {
          label: this.$t('dashboard.ji'),
          value: '2',
        },
        {
          label: this.$t('dashboard.nian'),
          value: '1',
        },
      ];
    },
  },
  data() {
    return {
      dashboardCount: {
        deviceCount: '',
        unCleanDeviceCount: '',
        expiringDeviceCount: '',
        useSiteCount: '',
        siteCount: '',
        noGoalSiteCount: '',
      },
      workOrderCount: '',
      expiringBillCount: '',
      kpiCount: {
        siteQualifyRate: '',
        useSiteQualifyRate: '',
        siteScoreAvg: '',
        useSiteScoreAvg: '',
        cleanAreaTotal: '',
        cleanTimeTotal: '',
        cleanDays: '',
        cleanAreaAvg: '',
        cleanTimeAvg: '',
        chargeAvg: '',
      },
      menuPathList: [], // 菜单路由列表
      reportType: '', // kpi类型
      startDate: '', // kpi开始时间
      endDate: '', // kpi结束时间
      beginTime: '',
      endTime: '',
      initValue: [], // 初始日期string(忽略时区,返回UTC)
      reportDateTime: [], // 类型-日
      reportYearTime: [], // 类型-年
      reportSeasonTime: [], // 类型-季
      reportMonthTime: [], // 类型-月
      reportWeekTime: [], // 类型-周

      lineList: [],
      lineList2: [],
      lineType: '',
      formSearch: {
        search: '',
        customerId: '',
        showSubsidiary: '',
        pageNum: 1,
        pageSize: 50,
      },
      cleanColumn: [],
      tableList: [],
      totalRows: 0,

      formSearch2: {
        search: '',
        customerId: '',
        showSubsidiary: '',
        pageNum: 1,
        pageSize: 50,
      },
      tableType: '',
      cleanColumn2: [],
      tableList2: [],
      totalRows2: 0,

      pickerEndDateTime: '',
    };
  },
  mounted: function () {
    this.getMenuList();
    this.getFuncView(null, () => {
      if (!(this.funcView.historyLine_cleanScore || this.funcView.historyLine_totalCleanArea || this.funcView.historyLine_totalUsageTime || this.funcView.historyLine_useDeviceSite)) {
        this.reportType = '3';
      } else {
        this.reportType = '5';
      }
      if (this.funcView.historyLine_cleanScore) {
        this.lineType = 'cleanScore';
      } else if (this.funcView.historyLine_totalCleanArea) {
        this.lineType = 'totalCleanArea';
      } else if (this.funcView.historyLine_totalUsageTime) {
        this.lineType = 'totalUsageTime';
      } else if (this.funcView.historyLine_useDeviceSite) {
        this.lineType = 'useDeviceSite';
      }
      if (this.funcView.historyReport) {
        this.tableType = 'cleanArea';
      } else if (this.funcView.historyTimeReport) {
        this.tableType = 'cleanTime';
      }

      this.onTypeChange();
      this.getDashboardCount();
      this.getWorkOrderCount();
      this.getTableColumn();
      this.getTableList();
      this.getTableList2();
    });
  },
  created() {
    moment.updateLocale('en', {
      week: {
        dow: 1, // Monday is the first day of the week.
        doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
      },
    });
    this.pickerEndDateTime = moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59');
    this.initValue = [moment(this.$getLocalTime()).subtract(15, 'day').format('YYYY-MM-DD 00:00:00'), moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59')];
    this.reportDateTime = this.initValue;
    this.reportYearTime = [`${moment(this.$getLocalTime()).subtract(4, 'year').year()}`, `${moment(this.$getLocalTime()).year()}`];
    this.reportMonthTime = [`${moment(this.$getLocalTime()).subtract(13, 'month').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).format('YYYY-MM')}`];
    this.reportWeekTime = [moment(this.$getLocalTime()).subtract(13, 'week'), moment(this.$getLocalTime())];
    this.reportSeasonTime = [
      moment(this.$getLocalTime())
        .subtract(13 * 3, 'month')
        .format('YYYY-0Q'),
      moment(this.$getLocalTime()).format('YYYY-0Q'),
    ];
  },
  methods: {
    getMenuList: function () {
      this.$getJSON(apis.App, { appCode: 'customer-portal' }).then((res) => {
        const arr = res.data || [];
        const list = this.$treeTransArray(arr, 'children');
        this.menuPathList = list.map(t => t.loadRes);
      });
    },
    // 卡片跳转
    onCardJump(path, query) {
      if (this.menuPathList.includes(path)) {
        this.jump(path, query);
      }
    },
    // 则线图
    getLineData: function () {
      this.$getJSON(apis.DashboardSummary, {
        reportType: this.reportType,
        beginTime: this.beginTime,
        endTime: this.endTime,
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.date = item.reportDate;
          const value = item.totalUsageTime / 60;
          const digit = 0;
          item.totalUsageTime = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit || '-';
          item.totalCleanArea = this.$formatLenLocal(item.totalCleanArea);
          item.goalArea = this.$formatLenLocal(item.goalArea); // 目标值
          item.cleanScore = item.cleanScore || '-';
        });
        this.lineList = list;
      });
      this.getLineDeviceSite();
    },
    // 折线图-活动区域
    getLineDeviceSite: function () {
      this.$getJSON(apis.DashboardDeviceSite, {
        reportType: this.reportType,
        beginTime: this.beginTime,
        endTime: this.endTime,
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.date = item.reportDate;
        });
        this.lineList2 = list;
      });
    },
    // 环形图
    formatPieDate: function (num, color) {
      if (num >= 90) {
        return [
          { color: color || 5, num: num },
          { color: 4, num: Math.round((100 - num) * 10 ** 1) / 10 ** 1 },
        ];
      } else if (num >= 70) {
        return [
          { color: color || 2, num: num },
          { color: 4, num: Math.round((100 - num) * 10 ** 1) / 10 ** 1 },
        ];
      } else {
        return [
          { color: color || 1, num: num },
          { color: 4, num: Math.round((100 - num) * 10 ** 1) / 10 ** 1 },
        ];
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    // Dashboard统计
    getDashboardCount() {
      this.$getJSON(apis.DashboardCount).then((res) => {
        this.dashboardCount = res.data || {};
      });
    },
    // 工单统计
    getWorkOrderCount() {
      this.$getJSON(apis.AsmCount).then((res) => {
        this.workOrderCount = res.data.workingCount;
      });
      this.$getJSON(apis.FmsCount).then((res) => {
        this.expiringBillCount = res.data.expiringBillCount;
      });
    },
    // KPI数据
    getKpiCount() {
      // 确保 startDate 不早于 2016年1月1日
      let finalStartDate = this.startDate;
      const minDate = '2016-01-01';
      if (moment(this.startDate).isBefore(minDate)) {
        finalStartDate = minDate;
      }
      this.$getJSON(apis.DashboardKpiCount, { reportType: this.reportType, beginTime: this.beginTime, endTime: this.endTime, startDate: finalStartDate, endDate: this.endDate }).then((res) => {
        this.kpiCount = res.data;
      });
    },
    // 日期切换
    onTypeChange() {
      switch (this.reportType) {
        case '1': // 年
          this.startDate = `${this.reportYearTime[0]}-01-01`;
          this.endDate = `${this.reportYearTime[1]}-12-31`;
          // 结束日期不能超过今天0点
          if (moment(this.endDate).isAfter(this.pickerEndDateTime)) {
            this.endDate = this.pickerEndDateTime;
          }
          this.beginTime = this.reportYearTime[0];
          this.endTime = this.reportYearTime[1];
          this.getKpiCount();
          this.getLineData();
          break;
        case '2': // 季
          this.startDate = moment(this.reportSeasonTime[0], 'YYYY-0Q').startOf('quarter').format('YYYY-MM-DD');
          this.endDate = moment(this.reportSeasonTime[1], 'YYYY-0Q').endOf('quarter').format('YYYY-MM-DD');
          // 结束日期不能超过今天0点
          if (moment(this.endDate).isAfter(this.pickerEndDateTime)) {
            this.endDate = this.pickerEndDateTime;
          }
          this.beginTime = this.reportSeasonTime[0];
          this.endTime = this.reportSeasonTime[1];
          this.getKpiCount();
          this.getLineData();
          break;
        case '3': // 月
          this.startDate = `${this.reportMonthTime[0]}-01`;
          this.endDate = moment(`${this.reportMonthTime[1]}-01 00:00:00`).add(1, 'month').subtract(1, 'seconds').format('YYYY-MM-DD');
          // 结束日期不能超过今天0点
          if (moment(this.endDate).isAfter(this.pickerEndDateTime)) {
            this.endDate = this.pickerEndDateTime;
          }
          this.beginTime = this.reportMonthTime[0];
          this.endTime = this.reportMonthTime[1];
          this.getKpiCount();
          this.getLineData();
          break;
        case '4': // 周
          this.startDate = moment(this.reportWeekTime[0], 'YYYY-ww').startOf('week').format('YYYY-MM-DD');
          this.endDate = moment(this.reportWeekTime[1], 'YYYY-ww').endOf('week').format('YYYY-MM-DD');
          // 结束日期不能超过今天0点
          if (moment(this.endDate).isAfter(this.pickerEndDateTime)) {
            this.endDate = this.pickerEndDateTime;
          }
          this.beginTime = moment(this.reportWeekTime[0]).format('gggg-ww');
          this.endTime = moment(this.reportWeekTime[1]).format('gggg-ww');
          this.getLineData();
          this.getKpiCount();
          break;
        case '5': // 日
          this.startDate = moment(this.$momentElLocal(this.reportDateTime[0])).format('YYYY-MM-DD');
          this.endDate = moment(this.$momentElLocal(this.reportDateTime[1])).format('YYYY-MM-DD');
          this.beginTime = moment(this.$momentElLocal(this.reportDateTime[0])).format('YYYY-MM-DD');
          this.endTime = moment(this.$momentElLocal(this.reportDateTime[1])).format('YYYY-MM-DD');
          this.getKpiCount();
          this.getLineData();
        // default: // 日
      }
    },
    // 区域清洁面积
    getTableColumn: function () {
      this.$getJSON(apis.TableColumnGet, { tableCode: 'portal_dashboard_site_clean' }).then((res) => {
        let list = res.data;
        if (!this.isCoJv) {
          list = list.filter(t => t.columnCode !== 'orgName');
        }
        const months = [
          {
            columnCode: 'month1',
            columnName: `${moment().format('YYYYMM')}(${this.$formatLenUnit()})`,
            selected: true,
          },
          {
            columnCode: 'month2',
            columnName: `${moment().subtract(1, 'months').format('YYYYMM')}(${this.$formatLenUnit()})`,
            selected: true,
          },
          {
            columnCode: 'month3',
            columnName: `${moment().subtract(2, 'months').format('YYYYMM')}(${this.$formatLenUnit()})`,
            selected: true,
          },
          {
            columnCode: 'month4',
            columnName: `${moment().subtract(3, 'months').format('YYYYMM')}(${this.$formatLenUnit()})`,
            selected: true,
          },
        ];
        const months2 = [
          {
            columnCode: 'month1',
            columnName: `${moment().format('YYYYMM')}(H)`,
            selected: true,
          },
          {
            columnCode: 'month2',
            columnName: `${moment().subtract(1, 'months').format('YYYYMM')}(H)`,
            selected: true,
          },
          {
            columnCode: 'month3',
            columnName: `${moment().subtract(2, 'months').format('YYYYMM')}(H)`,
            selected: true,
          },
          {
            columnCode: 'month4',
            columnName: `${moment().subtract(3, 'months').format('YYYYMM')}(H)`,
            selected: true,
          },
        ];
        this.cleanColumn = [...list, ...months];
        this.cleanColumn2 = [...list, ...months2];
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onPageChange2: function ({ page, size }) {
      this.formSearch2.pageNum = page;
      this.formSearch2.pageSize = size || this.formSearch2.pageSize;
      this.getTableList2();
    },
    getarrayMax: function (arr) {
      let max = 0;
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (!Number.isNaN(Number(item))) {
          max = item > max ? item : max;
        }
      }
      return Number.parseInt(max, 10);
    },
    // 获取表格数据
    getTableList() {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.DashboardSiteCleanPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.max = this.getarrayMax([item.month1, item.month2, item.month3, item.month4]);
          item.month11 = Number.parseInt((item.month1 / item.max) * 100, 10);
          item.month22 = Number.parseInt((item.month2 / item.max) * 100, 10);
          item.month33 = Number.parseInt((item.month3 / item.max) * 100, 10);
          item.month44 = Number.parseInt((item.month4 / item.max) * 100, 10);
          item.month1 = this.$formatLenLocal(item.month1);
          item.month2 = this.$formatLenLocal(item.month2);
          item.month3 = this.$formatLenLocal(item.month3);
          item.month4 = this.$formatLenLocal(item.month4);
        });
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableList2() {
      this.formSearch2.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.DashboardSiteTimePage, this.formSearch2).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.max = this.getarrayMax([item.month1, item.month2, item.month3, item.month4]);
          item.month11 = Number.parseInt((item.month1 / item.max) * 100, 10);
          item.month22 = Number.parseInt((item.month2 / item.max) * 100, 10);
          item.month33 = Number.parseInt((item.month3 / item.max) * 100, 10);
          item.month44 = Number.parseInt((item.month4 / item.max) * 100, 10);
          item.month1 = this.$formatSecToHh(item.month1);
          item.month2 = this.$formatSecToHh(item.month2);
          item.month3 = this.$formatSecToHh(item.month3);
          item.month4 = this.$formatSecToHh(item.month4);
        });
        this.tableList2 = list;
        this.totalRows2 = res.data.total;
      });
    },
    // 导出
    onExport: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('DashboardSiteCleanExport', this.formSearch);
    },
    // 导出
    onExport2: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('DashboardSiteTimeExport', this.formSearch);
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.dashboard-bd {
  padding: 0 24px 24px;
  .dashboard-wrap {
    position: relative;
    padding: 0 20px;
    overflow: hidden;
    border-radius: 16px 16px 0px 0px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 150px;
      z-index: 1;
      background: linear-gradient(#f1f1f2 0%, #f8f9fa 100%);
    }
    .bg-img {
      display: block;
      position: absolute;
      right: 0;
      z-index: 2;
    }
    .bg-box {
      position: relative;
      z-index: 10;
    }
  }

  .title {
    padding: 20px 0;
    h1 {
      height: 28px;
      line-height: 28px;
      margin-bottom: 8px;
      font-size: 20px;
      color: #0d9ae0;
      font-weight: bold;
      span {
        color: #1a1a1a;
      }
    }
    p {
      color: #4d4d4d;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .card {
    margin-bottom: 24px;
    & > .ub-f1 {
      height: 88px;
      border-radius: 16px;
      background-color: #ffffff;
      padding: 0 20px;
      margin-right: 16px;
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.03);
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      .box-l {
        h1 {
          font-weight: bold;
          line-height: 17px;
          color: $--color-text-secondary;
          font-size: 12px;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        p {
          margin-top: 8px;
          line-height: 30px;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .box-r {
        height: 40px;
        width: 40px;
        line-height: 40px;
        border-radius: 40px;
        text-align: center;
        background-color: $--color-primary;
        .icon {
          font-size: 24px;
          color: #ffffff;
        }
      }
    }
  }

  .report-box {
    padding: 24px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.03);
    border-radius: 16px;
    background-color: #ffffff;
    position: relative;
    z-index: 20;

    .filter {
      height: 40px;
      // 选择器
      .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 20px 0 0 20px;
      }

      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 0 20px 20px 0;
      }

      .select-date {
        .el-input__inner {
          height: 48px;
          line-height: 48px;
          border: none;
          width: 100%;
          font-size: 15px;
        }

        .el-range-input {
          font-weight: bold;
          font-size: 18px;
          color: #202945;
        }

        .el-range-separator {
          line-height: 40px;
        }

        .el-range__icon {
          color: $--color-primary;
          font-size: 18px;
        }

        .el-range__close-icon:after {
          font-family: 'icon' !important;
          content: '\E7F8';
          font-size: 22px;
          display: inline;
          height: 40px;
          line-height: 40px;
          color: $--color-warning;
        }

        .week-picker,
        .year-picker {
          .el-input__suffix .el-input__icon:after {
            height: 44px !important;
            line-height: 44px !important;
          }
        }
        .quarter-picker {
          .el-input__suffix .el-input__icon:before {
            height: 44px !important;
            line-height: 44px !important;
          }
        }
      }
    }

    .report {
      margin: 24px 0;
      & > .ub-f3 {
        margin-right: 10px;
        border-radius: 16px;
        border: 1px solid #f0f0f0;
        .wrap {
          padding: 16px 20px;
        }
        h1 {
          line-height: 48px;
          font-size: 14px;
          color: #1a1a1a;
          font-weight: bold;
          padding: 0 16px;
        }
        p {
          font-size: 12px;
          color: #1a1a1a;
          line-height: 26px;
          height: 26px;
          margin-top: 4px;
        }
      }
      & > .ub-f4 {
        .sub-box {
          border: 1px solid #f0f0f0;
          border-radius: 10px;
          padding: 16px;
          margin-right: 10px;
        }
        h1 {
          line-height: 16px;
          margin: 6px 0;
          font-size: 12px;
          color: #4d4d4d;
          font-weight: bold;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        p {
          color: #1a1a1a;
          font-size: 20px;
          font-weight: bold;
          line-height: 30px;
        }
      }
    }
  }

  .clean-box {
    background-color: #ffffff;
    padding: 24px;
    border-radius: 16px;
    margin-top: 24px;

    .org-select .el-input__inner {
      border-radius: 100px;
    }
  }

  .sub-title {
    font-weight: bold;
    color: #1a1a1a;
    font-size: 18px;
    line-height: 40px;
  }
}
</style>
